import axios from "axios";
import URL from "../../helpers/URL";
import configuration from "./configuration";


export const addVital = (data: any) => {
    let config = configuration();
    return axios.post(URL.addVital, data, config);
};

export const getVitalById = (id:any)=> {
  let config = configuration();
  return axios.get(URL.getLatestVital+id, config);
}

export const getLatestVitals = ()=> {
  let config = configuration();
  return axios.get(URL.getLatestVital, config);
}

export const getVitals = ()=> {
    let config = configuration();
    return axios.get(URL.getVitals, config);
  }

